<template>
  <div class="bodyTheme" v-if="$mq != 'mobile'">
    <div class="boxTitle">
      <div class="leftButton">
        <div class="title">{{ title }}</div>
      </div>
      <div class="buttonClass">
        <div @click="$router.push({ name: 'qrcode' })" class="qrcodeBtn">
          <img src="@/assets/qrcodelogo.png" />
        </div>
        <div @click="$router.push({ name: 'geoloc' })" class="geolocBtn" v-show="haveGeoloc">
          <img src="@/assets/geoloclogo.png" />
        </div>
        <div
          class="downloadBtn"
          @click.prevent="clickInterceptor"
          v-if="offlineStatus != 'no-offline'"
        >
          <download-button
            ref="download"
            content-type="theme"
            :content-id="id"
            @state-change="handleStateChange"
          />
        </div>
      </div>
    </div>
    <div class="boxBody">
      <div class="imgDomaine" :style="{ backgroundImage: 'url(' + bgImg + ')' }"></div>
    </div>
    <div class="circuit">
      <desktop-lesson-step-item
        v-for="lessonStep in lessonSteps"
        :key="lessonStep.id"
        :id="lessonStep.id"
        :masterclassId="theme.id"
      />
    </div>
  </div>
  <div v-else class="bodyTheme">
    <div class="imgDomaine" :style="{ backgroundImage: 'url(' + bgImg + ')' }"></div>
    <div class="bodyDetails">
      <div class="boxTitleMobile">
        <div
          class="downloadBtn"
          @click.prevent="clickInterceptor"
          v-if="offlineStatus != 'no-offline'"
        >
          <download-button
            ref="download"
            content-type="theme"
            :content-id="id"
            @state-change="handleStateChange"
          />
        </div>
        <div class="leftButton">
          <div class="titleMobile">{{ title }}</div>
        </div>
        <div @click="$router.push({ name: 'qrcode' })" class="qrcodeBtn">
          <img src="@/assets/qrcodelogo.png" />
        </div>
        <div @click="$router.push({ name: 'geoloc' })" class="geolocBtn" v-show="haveGeoloc">
          <img src="@/assets/geoloclogo.png" />
        </div>
      </div>
      <div class="circuitMobile">
        <desktop-lesson-step-item
          v-for="lessonStep in lessonSteps"
          :key="lessonStep.id"
          :id="lessonStep.id"
          :masterclassId="theme.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import { GENERATE_RANDOM_QUIZ } from '@/store/modules/quiz/types'
import { contentHasQuiz } from '@/store/modules/quiz/actions'
import { isLessonStepComplete, isLessonStepStarted } from '@/helpers/userCompletion'
import DownloadButton from '@/components/download/DownloadButton'
import DesktopLessonStepItem from '@/components/masterclass/DesktopLessonStepItem'

export default {
  name: 'Theme',
  components: {
    DesktopLessonStepItem,
    DownloadButton
  },
  mixins: [userMixin, remoteConfigMixin],
  props: {
    whitch: {
      type: String,
      required: false,
      default: 'learn'
    }
  },
  data() {
    return {
      type: this.whitch,
      offlineStatus: null,
      bgImg: require('@/assets/background-visite.jpg'),
      haveGeoloc: true
    }
  },
  mounted() {
    this.haveGeoloc = this.ifThemeHaveGeoloc()
  },

  computed: {
    ...mapGetters({
      theme: 'currentTheme',
      funnels: 'themeFunnels',
      lessonStepDuration: 'lessonStepDuration',
      getThemeById: 'getThemeById'
    }),
    id() {
      return this.$router.history.current.params.themeId
    },
    imageTile() {
      return this.$router.history.current.params.image
    },
    title() {
      if (!this.theme) return

      return this.theme.title
    },
    lessonSteps() {
      return this.theme ? this.theme.lessonSteps : []
    },
    progression() {
      if (!this.lessonSteps || this.lessonSteps.length === 0) return 0

      return this.lessonSteps.reduce(
        (accumulator, lessonStep) =>
          this.isLessonStepComplete(lessonStep.id) ? accumulator + 1 : accumulator,
        0
      )
    },
    total() {
      if (!this.lessonSteps) return 0

      return this.lessonSteps.length
    },
    funnel() {
      return this.funnels[this.theme.id]
    },
    numberOfQuizQuestion() {
      return get(this.theme, 'numberOfQuestions', 2)
    },
    showSwitches() {
      return (
        this.lessonSteps &&
        this.theme.tastings &&
        this.lessonSteps.length > 0 &&
        this.theme.tastings.length > 0
      )
    }
  },
  methods: {
    handleStateChange(status) {
      this.offlineStatus = status
    },
    setType(type) {
      this.type = type
    },
    hasQuiz() {
      if (this.theme) return contentHasQuiz('masterclass', this.theme.id, this.$store.state)
      else return false
    },
    isLessonStepComplete(lessonStepId) {
      return isLessonStepComplete(lessonStepId)
    },
    lessonStepStatus(lessonStepId) {
      if (this.isLessonStepComplete(lessonStepId)) return 'finished'

      if (isLessonStepStarted(lessonStepId)) return 'started'

      return 'unstarted'
    },
    generateAndOpenQuiz() {
      if (!this.remoteConfig.getBoolean('quiz_enabled')) return

      this.$store.dispatch(GENERATE_RANDOM_QUIZ, {
        contentType: 'masterclass',
        contentId: this.theme.id
      })

      this.$router.push({
        name: 'quiz',
        params: {
          quizId: this.theme.id,
          contentType: 'masterclass',
          contentId: this.theme.id
        }
      })
    },
    switchTab() {
      this.type = this.type === 'taste' ? 'learn' : 'taste'
    },
    haveData(value) {
      return value != null && value !== ''
    },
    ifThemeHaveGeoloc() {
      return (
        this.haveData(this.theme.coordinatesWineEstate) || this.haveData(this.theme.geojsonTrack)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.imgDomaine {
  background-size: cover;
  background-position: center;
  height: 25vh;
}

.circuitMobile {
  margin: 10px;
}
.bodyDetails {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 23px 23px 0 0;
  margin: -25px 0px 50px 0px;
  width: 100%;
  height: 100%;
}
.boxTitleMobile {
  display: flex;
  flex-direction: row;
  margin: 5px;
}
.leftButton {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.backButton {
  margin-right: 35px;
  cursor: pointer;
  background-color: #ffffff;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 3px 3px 3px #bebebe, -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
    box-shadow: -3px -3px 4px #bebebe, 3px 3px 2px #ffffff;
  }
}
.qrcodeBtn {
  height: 35px;
  padding: 8px;
  margin: 5px;
  border-radius: 50px;
  img {
    height: 100%;
    width: 100%;
  }
  cursor: pointer;
}
.geolocBtn {
  height: 40px;
  padding: 5px 12px;
  margin: 5px;
  border-radius: 50px;
  img {
    height: 100%;
    width: 100%;
  }
  cursor: pointer;
}
.downloadBtn {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 5px 10px;
  margin: 5px;
  border-radius: 50px;
  download-button {
    height: 100%;
    width: 100%;
  }
  cursor: pointer;
}
.buttonClass {
  display: flex;
  flex-direction: row;
  margin-left: 200px;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0px;
  color: #404040;
}
.titleMobile {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0px;
  color: #000000;
}
.img {
  width: 100%;
  height: auto;
}

.boxTitle {
  padding-top: 100px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: white;
  z-index: 1;
}

.bodyTheme {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
